import { connect } from 'react-redux'

import { fetchAllNDATemplates, updateNDATemplate, fetchNDATemplate } from 'src/legacy/redux/actions/ndaTemplate.jsx';
import NDATemplatesView from './view';
import hasAccess from 'src/legacy/services/hasAccess';
import withUseHooks from 'src/legacy/components/withUseHooks';

const mapStateToProps = (state, ownProps) => {
  return {
    templates: state.legacyRootReducer.settings.ndaTemplates.items,
    loading: state.legacyRootReducer.settings.ndaTemplates.loading,
    creating: state.legacyRootReducer.settings.ndaTemplates.creating,
    updating: state.legacyRootReducer.settings.ndaTemplates.updating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllNDATemplates: () => {
      return dispatch(fetchAllNDATemplates());
    },

    updateNDATemplate: (id, request) => {
      return dispatch(updateNDATemplate(id, request));
    },

    fetchNDATemplate: (id) => {
      return dispatch(fetchNDATemplate(id));
    } 

  }
}

const NDATemplatesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NDATemplatesView)

export default hasAccess(withUseHooks(NDATemplatesContainer), 'nda-template');